import { Helmet } from 'react-helmet';
import { T } from '@tolgee/react';
import { motion } from 'framer-motion';

const PoliticaCookies = () => {
  return (
    <>
      <Helmet>
        <title>Política de Cookies | Jarad</title>
        <meta name="description" content="Política de cookies de Jarad. Información sobre cómo utilizamos las cookies en nuestra web." />
      </Helmet>

      <div className="bg-gray-50 py-12">
        <motion.div 
          className="content-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-white shadow-sm rounded-lg p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              <T keyName="legal.cookies.title" />
            </h1>
            
            <div className="prose prose-blue max-w-none">
              <p className="text-gray-600">
                <T keyName="legal.cookies.last_updated" params={{date: new Date().toLocaleDateString()}} />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.introduction.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.introduction.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.what_are.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.what_are.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.types.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.types.content" />
              </p>
              
              <h3 className="text-lg font-semibold mt-6 mb-3">
                <T keyName="legal.cookies.types.essential.title" />
              </h3>
              <p>
                <T keyName="legal.cookies.types.essential.content" />
              </p>
              
              <h3 className="text-lg font-semibold mt-6 mb-3">
                <T keyName="legal.cookies.types.preferences.title" />
              </h3>
              <p>
                <T keyName="legal.cookies.types.preferences.content" />
              </p>
              
              <h3 className="text-lg font-semibold mt-6 mb-3">
                <T keyName="legal.cookies.types.statistics.title" />
              </h3>
              <p>
                <T keyName="legal.cookies.types.statistics.content" />
              </p>
              
              <h3 className="text-lg font-semibold mt-6 mb-3">
                <T keyName="legal.cookies.types.marketing.title" />
              </h3>
              <p>
                <T keyName="legal.cookies.types.marketing.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.control.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.control.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.third_party.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.third_party.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.updates.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.updates.content" />
              </p>
              
              <h2 className="text-xl font-semibold mt-8 mb-4">
                <T keyName="legal.cookies.contact.title" />
              </h2>
              <p>
                <T keyName="legal.cookies.contact.content" />
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default PoliticaCookies; 